<script>
import {VueMaskDirective as mask} from 'v-mask'
import { REAL_BRL } from '../../../../utils/helpers/money'
import { VMoney } from 'v-money'
import service, {buscaCep} from '../../../../domain/grv/services'
import {cadastro, cadastroSemBoleto} from '../../../../domain/pre-retirada/services'
import {debounce, isArray} from 'lodash'
import moment from 'moment'
import {
  PATIO_ENGENHO_DA_RAINHA,
  GRV_POLICIA_CIVIL,
  GRV_PREFEITURA,
  GRV_CAMPOS_DOS_GOYTACAZES
} from '../../../../domain/grv/helpers/tipos-grv'
import estadosBrasileiros from '../../../_default/utils/estados-brasileiros'
import {validaDocumento} from '../../../../utils/helpers/validators'

export default {
  nome: 'PreRetirada',
  directives: {mask, money: VMoney},
  data () {
    return {
      money: REAL_BRL,
      isLoading: false,
      data: null,
      documentoError: null,
      preretirada: {
        dataPrevista: null,
        nomePagador: null,
        tipoDocumento: 1,
        documentoPagador: null,
        cepPagador: null,
        enderecoPagador: null,
        numeroPagador: null,
        complementoPagador: null,
        bairroPagador: null,
        cidadePagador: null,
        estadoPagador: 'RJ',
        valor: null,
        referencia: null,
        dataPagamento: null,
        urlBoleto: null,
        pagamentoExterno: false,
        cobrarTaxaNotificacaoAR: false,
        status: null,
        complementar: false
      },
      extraModel: {
        cpf: null,
        cnpj: null
      },
      cadastroError: null,
      isPreenchidoAutomaticamente: false,
      estadosBrasileiros
    }
  },
  computed: {
    isGrvPoliciaCivil () {
      return this.data.tipoProcesso === GRV_POLICIA_CIVIL
    },
    isCobrancaSemBoleto () {
      return this.data.patio.naoEmitirBoleto || [GRV_PREFEITURA, GRV_CAMPOS_DOS_GOYTACAZES].some(p => p === this.data.tipoProcesso)
    },
    blockPatio () {
      return [
        PATIO_ENGENHO_DA_RAINHA
      ].some(p => p === this.data.patio.id)
    }
  },
  mounted () {
    this.start()
  },
  activated () {
  },
  destroyed () {
  },
  methods: {
    start () {
      this.$loaderOverlay.open().message('Definindo parâmetros da pré-retirada')
      service.find(this.$route.params.id, this.isGgv)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.data = response.data

          const {atendimentos} = this.data
          if (!atendimentos.length) return
          this.isPreenchidoAutomaticamente = true

          const atendimento = atendimentos[atendimentos.length - 1]
          this.preretirada.nomePagador = atendimento.nome
          this.extraModel.cpf = atendimento.cpf
          this.preretirada.cepPagador = atendimento.cep
          this.preretirada.enderecoPagador = atendimento.logradouro
          this.preretirada.numeroPagador = atendimento.numero
          this.preretirada.complementoPagador = atendimento.complemento
          this.preretirada.bairroPagador = atendimento.bairro
          this.preretirada.cidadePagador = atendimento.cidade
          this.preretirada.estadoPagador = atendimento.uf
          this.preretirada.dataPrevista = atendimento.dataAgendamento ? moment(atendimento.dataAgendamento.date).format('L LT') : null
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    validaDocumento () {
      const cpfValue = this.extraModel.cpf
      const cnpjValue = this.extraModel.cnpj

      if (cpfValue && !validaDocumento(cpfValue)) {
        this.documentoError = 'CPF inválido'
        return false
      } else if (cnpjValue && !validaDocumento(cnpjValue)) {
        this.documentoError = 'CNPJ inválido'
        return false
      } else if (!cpfValue && !cnpjValue) {
        this.documentoError = 'Por favor, insira um CPF ou CNPJ'
        return false
      } else {
        this.documentoError = null
        return true
      }
    },
    limpaFormularioCep () {
      this.preretirada.enderecoPagador = ''
      this.preretirada.bairroPagador = ''
      this.preretirada.cidadePagador = ''
      this.preretirada.estadoPagador = 'RJ'
    },
    pesquisarCep: debounce(function () {
      let cep = this.getOnlyNumbers(this.preretirada.cepPagador)
      if (cep.length !== 8) return
      buscaCep(cep)
        .then(({data}) => {
          this.preretirada.enderecoPagador = data.logradouro
          this.preretirada.bairroPagador = data.bairro
          this.preretirada.cidadePagador = data.localidade
          this.preretirada.complementoPagador = data.complemento
          this.preretirada.estadoPagador = data.uf
          this.$refs.endNumero.focus()
        })
        .catch((error) => {
          console.log(error)
        })
    }, 500),
    submit () {
      let confirm = window.confirm('Tem certeza que deseja registrar a pré-retirada?')
      if (!confirm) return

      if (this.isDataPrevistaMenorQueHoje()) {
        alert('Data prevista para retirada não pode ser menor que a data atual.')
        this.$refs.dataPrevista && this.$refs.dataPrevista.focus()
        return
      }

      if (!this.validaDocumento()) {
        return alert('Por favor, insira um CPF ou CNPJ  válido.')
      }

      this.cadastroError = null
      this.$loaderOverlay.open().message('Processando')
      this.$bar.start()
      window.setTimeout(() => {
        this.$loaderOverlay.message('Aguarde, registrando pré-retirada...')
      }, 1000)
      let data = JSON.parse(JSON.stringify(this.preretirada))
      data.grv = this.data.id

      const tiposDocumento = {1: 'cpf', 2: 'cnpj'}
      const tipoDocumento = tiposDocumento[data.tipoDocumento]
      data.documentoPagador = this.getOnlyNumbers(this.extraModel[tipoDocumento])
      data.cepPagador = this.getOnlyNumbers(data.cepPagador)
      data.valor = data.valor && data.valor.replace('R$', '').trim().replace(/\./, '').replace(/,/, '.')

      const fn = this.isCobrancaSemBoleto ? cadastroSemBoleto : cadastro
      fn(data)
        .then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            const name = this.isGrvPoliciaCivil ? 'roubo-furto.visualizar.patio' : 'grv.visualizar.patio'
            this.$router.push({name, params: {id: this.data.id}})
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    },
    isDataPrevistaMenorQueHoje () {
      const hoje = new Date()
      const hojeFormatado = [hoje.getFullYear(), hoje.getMonth() + 1, hoje.getDate()].map(item => String(item).padStart(2, '0')).join('-')
      const dataPrevistaFormatoEn = this.preretirada.dataPrevista.split('/').reverse().join('-')
      return (new Date(hojeFormatado)).getTime() > (new Date(dataPrevistaFormatoEn)).getTime()
    },
    getOnlyNumbers (string) {
      return String(string).replace(/\D/g, '')
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="data">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-warning lter b-b wrapper-md" v-if="isPreenchidoAutomaticamente">
              <div class="row">
                <div class="col-xs-12">
                  <h1 class="font-thin h4 text-black">
                    <strong>Atenção</strong><br>
                    Os campos foram preenchidos automaticamente com base nos dados do último agendamento realizado para
                    esta GRV.
                    <br>
                    É recomendado conferir os dados antes de confirmar.
                  </h1>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="clearfix">
                <div>
                  <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                    <div class="bg-light lter b-b wrapper-md">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <h1 class="font-thin h3">
                            Pré-Retirada
                          </h1>
                        </div>
                      </div>
                    </div>

                    <div class="wrapper">
                      <div class="panel-body">
                        <div v-if="data.preretiradas && data.preretiradas.length > 0" class="alert alert-warning">
                          Já existe(m) pré-retirada(s) registrada(s) para esta GRV. Ao registrar uma nova, você
                          cancelará as anteriores que estiverem com pagamento pendente.
                        </div>

                        <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                          <div class="m-b-sm font-bold">Erro ao registrar a pré-retirada, corrija e tente novamente
                          </div>
                          <p v-for="(erro, key) in cadastroError">{{ printError(erro) }}</p>
                        </div>

                        <div class="form-group lbl-form">
                          <label class="col-sm-2">GRV</label>
                          <div class="col-sm-10 font-bold">
                            {{ data.numero }} - {{ isGrvPoliciaCivil ? data.placaOriginal : data.placa }}
                          </div>
                        </div>

                        <div class="form-group lbl-form">
                          <label for="pagamentoExterno" class="col-sm-2">Cobrança Externa?</label>
                          <div class="col-sm-10 font-bold">
                            <input id="pagamentoExterno" type="checkbox" v-model="preretirada.pagamentoExterno">
                          </div>
                        </div>

                        <div class="form-group lbl-form" v-if="isGrvPoliciaCivil || !blockPatio">
                          <label for="cobrarTaxaAR" class="col-sm-2">Cobrar taxa de notificação AR?</label>
                          <div class="col-sm-10 font-bold">
                            <input id="cobrarTaxaAR" type="checkbox" v-model="preretirada.cobrarTaxaNotificacaoAR">
                            <span class="text-danger text-sm font-normal" v-if="preretirada.cobrarTaxaNotificacaoAR">
                              (Será adicionada uma taxa de R$ {{ data.taxaNotificacaoAR | moeda }} ao valor total, referente à notificação AR)
                            </span>
                          </div>
                        </div>


                        <div class="form-group lbl-form">
                          <label for="complementar" class="col-sm-2">Boleto complementar</label>
                          <div class="col-sm-10 font-bold">
                            <input id="complementar" type="checkbox" v-model="preretirada.complementar">
                          </div>
                        </div>

                        <div v-if="preretirada.pagamentoExterno">
                          <div class="form-group">
                            <label for="dataPagamento" class="col-sm-2 control-label">Data de Pagamento</label>
                            <div class="col-sm-10">
                              <input required id="dataPagamento" type="text" placeholder="dd/mm/yyyy"
                                     v-model="preretirada.dataPagamento"
                                     v-mask="'##/##/####'" class="form-control">
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="numeroDocumento" class="col-sm-2 control-label">Número do Documento</label>
                            <div class="col-sm-8">
                              <input required id="numeroDocumento" type="text" v-model="preretirada.referencia"
                                     class="form-control">
                            </div>
                            <div class="col-sm-2">
                              <a class="btn btn-info">Consultar</a>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="valorDocumento" class="col-sm-2 control-label">Valor do Documento</label>
                            <div class="col-sm-10">
                              <input required id="valorDocumento" type="text" v-model="preretirada.valor"
                                     class="form-control" placeholder="R$ 0,00" v-money="money">
                              <div class="m-t-xs">Valor do boleto apresentado</div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="dataPrevista" class="col-sm-2 control-label">Data prevista para retirada</label>
                          <div class="col-sm-10">
                            <input required id="dataPrevista" ref="dataPrevista" type="text" placeholder="dd/mm/yyyy"
                                   v-model="preretirada.dataPrevista"
                                   v-mask="'##/##/####'" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>

                    <!---->
                    <div class="bg-light lter b-b wrapper-md">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <h1 class="font-thin h3">
                            Dados do Pagador
                          </h1>
                        </div>
                      </div>
                    </div>

                    <div class="wrapper">
                      <div class="panel-body">
                        <div class="form-group">
                          <label for="nomePagador" class="col-sm-2 control-label">Nome</label>
                          <div class="col-sm-10">
                            <input autocomplete="off" required id="nomePagador" type="text"
                                   v-model="preretirada.nomePagador"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Tipo documento</label>
                          <div class="col-sm-10">
                            <select required v-model="preretirada.tipoDocumento" class="form-control">
                              <option :value="1">CPF</option>
                              <option :value="2">CNPJ</option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="documentoPagador" class="col-sm-2 control-label">Número documento</label>
                          <div class="col-sm-10" v-if="preretirada.tipoDocumento === 1">
                            <input autocomplete="off" required id="documentoPagador" type="text"
                                   v-model="extraModel.cpf"
                                   v-mask="'###.###.###-##'"
                                   class="form-control"
                                   @blur="validaDocumento"/>
                            <span v-if="documentoError" class="text-danger">{{ documentoError }}</span>
                          </div>
                          <div class="col-sm-10" v-else>
                            <input autocomplete="off" required id="documentoPagador" type="text"
                                   v-model="extraModel.cnpj"
                                   v-mask="'##.###.###/####-##'"
                                   class="form-control"
                                   @blur="validaDocumento"/>
                            <span v-if="documentoError" class="text-danger">{{ documentoError }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!---->
                    <div class="bg-light lter b-b wrapper-md">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <h1 class="font-thin h3">
                            Endereço Pagador
                          </h1>
                        </div>
                      </div>
                    </div>

                    <div class="wrapper">
                      <div class="panel-body">
                        <div class="form-group">
                          <label for="cep" class="col-sm-2 control-label">CEP</label>
                          <div class="col-sm-10">
                            <input required @keyup="pesquisarCep" id="cep" type="text" v-model="preretirada.cepPagador"
                                   v-mask="'##.###-###'"
                                   class="form-control" placeholder="00000-000" autocomplete="off">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="endereco" class="col-sm-2 control-label">Endereço</label>
                          <div class="col-sm-10">
                            <input required id="endereco" type="text" v-model="preretirada.enderecoPagador"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="numero" class="col-sm-2 control-label">Número</label>
                          <div class="col-sm-10">
                            <input required id="numero" ref="endNumero" type="text" v-model="preretirada.numeroPagador"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="complemento" class="col-sm-2 control-label">Complemento</label>
                          <div class="col-sm-10">
                            <input id="complemento" type="text" v-model="preretirada.complementoPagador"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="bairro" class="col-sm-2 control-label">Bairro</label>
                          <div class="col-sm-10">
                            <input required id="bairro" type="text" v-model="preretirada.bairroPagador"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="cidade" class="col-sm-2 control-label">Cidade</label>
                          <div class="col-sm-10">
                            <input required id="cidade" type="text" v-model="preretirada.cidadePagador"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Estado</label>
                          <div class="col-sm-10">
                            <select required v-model="preretirada.estadoPagador" class="form-control" id="id_pessoa_uf"
                                    name="pessoa_uf">
                              <option :value="estado.sigla" v-for="estado in estadosBrasileiros" :key="estado.sigla">
                                {{ estado.nome }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="wrapper">
                      <div class="panel-body">
                        <div class="row">
                          <button class="btn btn-success btn-md m-l-xs">Registrar Pré-Retirada</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// addPreretirada.vue?b4754e7e